export default {
  nodes: [
		{
			id: '11',
			name: '初入职场',
		},
    {
      id: '1',
      name: '出纳',
      conf: [],
    },
    {
      id: '2',
      name: '会计',
      conf: [],
    },
    {
      id: '3',
      name: '财务分析',
      conf: [],
    },
    {
      id: '4',
      name: '税务管理',
      conf: [],
    },
    {
      id: '5',
      name: '成本控制',
      conf: [],
    },
    {
      id: '6',
      name: '财务主管',
      conf: [],
    },
    {
      id: '7',
      name: '财务经理',
      conf: [],
    },
    {
      id: '8',
      name: '财务总监/CFO',
      conf: [],
    },
    {
      id: '9',
      name: '总会计师',
      conf: [],
    },
    {
      id: '10',
      name: '战略规划',
      conf: [],
    }
  ],
  edges: [
    {
      source: '1',
      target: '6',
    },
    {
      source: '2',
      target: '6',
    },
    {
      source: '3',
      target: '6',
    },
    {
      source: '4',
      target: '6',
    },
    {
      source: '5',
      target: '6',
    },
    {
      source: '6',
      target: '7',
    },
    {
      source: '7',
      target: '8',
    },
    {
      source: '7',
      target: '9',
    },
    {
      source: '7',
      target: '10',
    },
    {
      source: '11',
      target: '1',
    },
    {
      source: '11',
      target: '2',
    },
    {
      source: '11',
      target: '3',
    },
    {
      source: '11',
      target: '4',
    },
    {
      source: '11',
      target: '5',
    },
  ],
};